import {createReducer} from '@reduxjs/toolkit';
import {selectFeatures, selectProduct} from '@src/actions/quotaManagement.ts';
import {type FeatureRef} from '@src/types/featureCollections.ts';
import {type Product} from '@src/types/products.ts';

type QuotaManagementState = {
  selectedFeatures: FeatureRef[];
  selectedProduct: Product | null;
};

export const initialState: QuotaManagementState = {
  selectedFeatures: [],
  selectedProduct: null,
};

export default createReducer(initialState, builder => {
  builder.addCase(selectFeatures, (state, {payload}) => {
    state.selectedFeatures = payload ?? [];
  });

  builder.addCase(selectProduct, (state, {payload}) => {
    state.selectedProduct = payload ?? null;
  });
});
